(() => {
  'use strict';
  if (customElements.get('avora-full-set')) return;
  customElements.define('avora-full-set', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const configNode = this.querySelector('[data-avfs-config]');
      if (!configNode) return;
      this.config = JSON.parse(configNode.textContent);
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.scope = this.closest('product-info');
      this.body = this.querySelector('[data-avfs-body]');
      this.toggle = this.querySelector('[data-avfs-toggle]');
      this.form = this.querySelector('[data-avfs-form]');
      this.button = this.querySelector('[data-avfs-add]');
      this.label = this.querySelector('[data-avfs-add-label]');
      this.status = this.querySelector('[data-avfs-status]');
      this.selects = [...this.querySelectorAll('[data-avfs-color]')];
      this.pickers = [...this.querySelectorAll('[data-avfs-picker]')];
      this.pickers.forEach(picker => {
        picker.hidden = false;
        picker.parentElement.querySelector('[data-avfs-color]').hidden = true;
      });
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-avfs-color-trigger]');
        const option = event.target.closest('[data-avfs-color-option]');
        if (trigger) {
          const picker = trigger.closest('[data-avfs-picker]');
          if (trigger.getAttribute('aria-expanded') === 'true') this.closePicker(picker, true);
          else this.openPicker(picker);
        } else if (option) this.chooseColor(option);
      }, options);
      this.addEventListener('keydown', event => this.pickerKeydown(event), options);
      document.addEventListener('pointerdown', event => {
        this.pickers.forEach(picker => { if (!picker.contains(event.target)) this.closePicker(picker); });
      }, options);
      this.addEventListener('focusout', event => {
        this.pickers.forEach(picker => { if (!picker.contains(event.relatedTarget)) this.closePicker(picker); });
      }, options);
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'fi-FI', {style:'currency',currency:this.dataset.currency || 'EUR'});
      const initial = this.config.variants.find(v => String(v.id) === this.dataset.initialId);
      if (this.dataset.mode === 'product' && initial) this.selects.forEach((s,i) => { s.value = initial.options[i]; });
      this.toggle?.addEventListener('click', () => this.activate(this.dataset.active !== 'true'), options);
      this.scope?.addEventListener('click', event => {
        if (this.dataset.mode !== 'offer' || this.contains(event.target)) return;
        if (event.target.closest('.Avada-Bundle-Offer__Volume,variant-selects,.product-form__quantity')) this.activate(false);
      }, {...options,capture:true});
      this.scope?.addEventListener('change', event => {
        if (this.dataset.mode !== 'offer' || this.contains(event.target)) return;
        if (event.target.closest('.Avada-Bundle-Offer__Volume,variant-selects,.product-form__quantity')) this.activate(false);
      }, {...options,capture:true});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-avfs-color]')) { this.status.textContent = ''; this.sync(); }
      }, options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.add(); }, options);
      this.activate(this.dataset.mode === 'product');
    }
    activate(active) {
      if (!active) this.pickers.forEach(picker => this.closePicker(picker));
      this.dataset.active = String(active);
      this.body.hidden = !active;
      if (this.dataset.mode === 'offer') this.toggle?.setAttribute('aria-pressed', String(active));
      this.toggle?.setAttribute('aria-expanded', String(active));
      if (this.dataset.mode === 'offer') this.scope?.classList.toggle('avfs-active', active);
      this.sync();
      this.dispatchEvent(new Event('change', {bubbles:true}));
    }
    sync() {
      const colors = this.selects.map(s => s.value);
      this.variant = this.config.variants.find(v => v.options.every((color,i) => color === colors[i]));
      this.querySelector('[data-avfs-id]').value = this.variant?.id || '';
      this.selects.forEach(select => {
        const row = select.closest('.avfs-component');
        const image = row.querySelector('[data-avfs-color-trigger] img');
        const src = select.selectedOptions[0]?.dataset.image;
        if (image && src && image.getAttribute('src') !== src) { image.removeAttribute('srcset'); image.src = src; }
        const label = row.querySelector('[data-avfs-selected-text]');
        if (label) label.textContent = select.value;
        row.querySelectorAll('[data-avfs-color-option]').forEach(option => option.setAttribute('aria-selected', String(option.dataset.value === select.value)));
      });
      this.querySelector('[data-avfs-price]').textContent = this.money.format((this.variant?.price ?? this.config.price) / 100);
      this.button.disabled = Boolean(this.busy || !this.config.sellable || !this.variant?.available);
      this.label.textContent = this.busy ? this.config.labels.adding : !this.config.sellable ? this.config.labels.soon : !this.variant?.available ? this.config.labels.unavailable : this.config.labels.add;
    }
    openPicker(picker, edge) {
      this.pickers.forEach(other => { if (other !== picker) this.closePicker(other); });
      picker.querySelector('[data-avfs-color-list]').hidden = false;
      picker.querySelector('[data-avfs-color-trigger]').setAttribute('aria-expanded', 'true');
      const choices = [...picker.querySelectorAll('[data-avfs-color-option]')];
      const target = edge === 'last' ? choices.at(-1) : edge === 'first' ? choices[0] : choices.find(o => o.getAttribute('aria-selected') === 'true') || choices[0];
      target?.focus({preventScroll:true});
    }
    closePicker(picker, restoreFocus = false) {
      picker.querySelector('[data-avfs-color-list]').hidden = true;
      const trigger = picker.querySelector('[data-avfs-color-trigger]');
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreFocus) trigger.focus({preventScroll:true});
    }
    chooseColor(option) {
      const picker = option.closest('[data-avfs-picker]');
      const select = picker.parentElement.querySelector('[data-avfs-color]');
      select.value = option.dataset.value;
      select.dispatchEvent(new Event('change', {bubbles:true}));
      this.closePicker(picker, true);
    }
    pickerKeydown(event) {
      const picker = event.target.closest('[data-avfs-picker]');
      if (!picker) return;
      const trigger = event.target.closest('[data-avfs-color-trigger]');
      const option = event.target.closest('[data-avfs-color-option]');
      const choices = [...picker.querySelectorAll('[data-avfs-color-option]')];
      if (event.key === 'Escape') { event.preventDefault(); this.closePicker(picker, true); }
      else if (event.key === 'Tab') {
        // Restore focus to the trigger before native tab navigation leaves the control.
        this.closePicker(picker, true);
      } else if (trigger && ['ArrowDown','ArrowUp'].includes(event.key)) {
        event.preventDefault(); this.openPicker(picker, event.key === 'ArrowUp' ? 'last' : undefined);
      } else if (option && ['Enter',' '].includes(event.key)) {
        event.preventDefault(); this.chooseColor(option);
      } else if (option && ['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
        event.preventDefault();
        const current = choices.indexOf(option);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (current + (event.key === 'ArrowDown' ? 1 : -1) + choices.length) % choices.length;
        choices[next].focus();
      } else if (option && event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
        const next = choices.find(o => o.dataset.value.toLocaleLowerCase().startsWith(event.key.toLocaleLowerCase()));
        if (next) { event.preventDefault(); next.focus(); }
      }
    }
    async add() {
      if (this.busy || this.button.disabled || !this.form.reportValidity()) return;
      this.busy = true;
      this.sync();
      this.status.textContent = '';
      this.button.setAttribute('aria-busy','true');
      const variant = this.variant;
      const quantity = 1;
      const drawer = document.querySelector('cart-drawer');
      const data = new FormData(this.form);
      data.set('id', String(variant.id));
      data.set('quantity', '1');
      if (drawer?.getSectionsToRender) {
        data.append('sections', drawer.getSectionsToRender().map(section => section.id).join(','));
        data.append('sections_url', location.pathname);
        drawer.setActiveElement?.(this.button);
      }
      const Standard = window.StandardEvents?.CartLinesUpdateEvent;
      let deferred = null;
      if (Standard?.createPromise) {
        try {
          deferred = Standard.createPromise();
          deferred.promise.catch(() => {});
          this.dispatchEvent(new Standard({action:'add',context:'product',lines:[{merchandiseId:String(variant.id),quantity}],promise:deferred.promise}));
        } catch (_) { deferred = null; }
      }
      let committed = false;
      try {
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || this.config.labels.error);
        committed = true;
        this.status.textContent = this.config.labels.added;
        if (deferred) fetch(this.dataset.cartUrl + '.js').then(r => r.json()).then(cart => deferred.resolve({cart:Standard.createCartFromAjaxResponse(cart)})).catch(error => deferred.reject(error));
        const sectionsReady = drawer?.getSectionsToRender?.().every(section => typeof result.sections?.[section.id] === 'string');
        if (drawer?.renderContents && sectionsReady) { drawer.classList.remove('is-empty'); drawer.renderContents(result); }
        else location.assign(this.dataset.cartUrl);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const notified = publish(PUB_SUB_EVENTS.cartUpdate, {source:'avora-full-set',productVariantId:String(variant.id),cartData:result});
          notified?.catch(() => {});
        }
      } catch (error) {
        if (committed) location.assign(this.dataset.cartUrl);
        else { deferred?.reject(error); this.status.textContent = error.name === 'TypeError' ? this.config.labels.error : error.message; }
      } finally {
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.sync();
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dataset.mode === 'offer') this.scope?.classList.remove('avfs-active');
    }
  });
})();
